import {
  BREAKPOINTS_V3,
  ModalV3,
  useMediaQuery,
} from '@jouzen/ecom-components';

import { EventType } from '@/analytics/types';
import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';
import useMatchUserCountry from '@/app/hooks/useMatchUserCountry';

import DesktopSizeModal from './SizeModalDesktop';
import JapanSizeModal from './SizeModalJapan';
import MobileSizeModal from './SizeModalMobile';

interface ProductSizingModalProps {
  readonly sizeModal: boolean;
  readonly setSizeModal: (sizeModal: boolean) => void;
}

const ProductSizingModal = ({
  sizeModal,
  setSizeModal,
}: ProductSizingModalProps): JSX.Element => {
  const { isAccessory, isOuraRing4Wizard } = useWizardStateContext();
  const isMediumScreen = useMediaQuery(
    `(min-width: ${BREAKPOINTS_V3.medium}px)`,
  );
  const isJapan = useMatchUserCountry('JP');
  const location = isAccessory ? 'accessory_wizard_pdp' : 'ring_wizard_pdp';

  const handleSizingPageLink = async (loc: string): Promise<void> => {
    await window.ouraAnalytics.track(EventType.LinkClicked, {
      title: 'route_to_size_page',
      location: loc,
    });
  };

  return (
    <ModalV3
      isOpen={sizeModal}
      onOpenChange={() => setSizeModal(!sizeModal)}
      size="large"
      variant="lightest"
      className="md:rounded-xl"
    >
      {isJapan && (
        <JapanSizeModal
          onSizeLinkClick={() => handleSizingPageLink(location)}
        />
      )}
      {!isJapan && isMediumScreen && (
        <DesktopSizeModal
          onSizeLinkClick={() => handleSizingPageLink(location)}
          isOuraRing4Wizard={isOuraRing4Wizard}
        />
      )}
      {!isJapan && !isMediumScreen && (
        <MobileSizeModal
          onSizeLinkClick={() => handleSizingPageLink(location)}
          isOuraRing4Wizard={isOuraRing4Wizard}
        />
      )}
    </ModalV3>
  );
};

export default ProductSizingModal;
